import { Injectable, signal } from '@angular/core';

/** docs/design/16_workflow_engine.md §14.3 — one Validation step that failed during the current user's own
 * action. Both texts are the admin's own (never machine-translated); the banner shows the viewer's language. */
export interface WorkflowValidationNotice {
  stepName: string;
  messageEn: string;
  messageAr: string;
}

/** Holds the Validation failure message(s) the API just reported for the user's OWN action (via the
 * `X-Workflow-Validation-Failures` response header - see `workflowValidationInterceptor`), for
 * `WorkflowNoticeBannerComponent` to show until dismissed. A new action replaces the previous notice. */
@Injectable({ providedIn: 'root' })
export class WorkflowNoticeService {
  readonly notices = signal<WorkflowValidationNotice[]>([]);

  /** docs/design/16_workflow_engine.md §18.17 - the backend's own localized text (the error envelope `message`) for a
   * workflow write step that failed during the user's own action; the banner shows it as is. */
  readonly errorMessage = signal<string | null>(null);

  showError(message: string): void {
    this.errorMessage.set(message);
  }

  show(notices: WorkflowValidationNotice[]): void {
    this.notices.set(notices);
  }

  dismiss(): void {
    this.notices.set([]);
    this.errorMessage.set(null);
  }
}
